const REVIEWER_UI_RULES = {
  peer: {
    started: 'started_peer_review',
    awaiting: ['awaiting_peer_reviewer'],
    uploaded: 'uploaded_peer_review',
    failed: ['failed_peer_review'],
  },
  site: {
    started: 'started_site_review',
    awaiting: ['awaiting_site_reviewer'],
    uploaded: 'uploaded_site_review',
    failed: ['failed_site_review'],
  },
  director: {
    started: 'started_director_review',
    awaiting: ['awaiting_director_reviewer'],
    uploaded: 'uploaded_director_review',
    failed: ['failed_director_review'],
  },
  fieldEngineer: {
    started: 'started_field_engineer',
    awaiting: ['awaiting_field_engineer'],
    uploaded: 'uploaded_field_engineer',
    failed: ['failed_peer_review', 'failed_site_review', 'failed_director_review'],
  },
};

export const shouldStartOnDownload = (lastStatus, roleKey) => {
  const rules = REVIEWER_UI_RULES[roleKey];
  if (!rules || !lastStatus) return false;
  if (rules.awaiting.includes(lastStatus)) return true;
  if (rules.failed.includes(lastStatus)) return true;
  return false;
};

export const getReviewerStartedStatus = (roleKey) =>
  REVIEWER_UI_RULES[roleKey]?.started ?? null;

export const getReviewerUploadedStatus = (roleKey) =>
  REVIEWER_UI_RULES[roleKey]?.uploaded ?? null;
